var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tabs',_vm._g(_vm._b({staticClass:"treatment-timeline-tabs",scopedSlots:_vm._u([{key:"custom-tabs",fn:function(ref){
var label = ref.label;
return _c('span',{staticClass:"treatment-timeline-tabs__tab-label"},[_vm._v(" "+_vm._s(_vm.getTabLabel(label))+" ")])}}])},'tabs',_vm.$attrs,false),_vm.$listeners),[_vm._t("tab-content",null,{"slot":"tab-content"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }